import { render, staticRenderFns } from "./culture.vue?vue&type=template&id=486f261a&scoped=true&"
import script from "./culture.vue?vue&type=script&lang=js&"
export * from "./culture.vue?vue&type=script&lang=js&"
import style0 from "./culture.vue?vue&type=style&index=0&id=486f261a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486f261a",
  null
  
)

export default component.exports